var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityFinanceAccommodation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 41.531,
    viewBox: "0 0 42 41.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(-0.5 -0.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(0.5 0.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3384",
    "data-name": "Rectangle 3384",
    width: 42,
    height: 5,
    rx: 2,
    transform: "translate(0 36.531)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55426",
    "data-name": "Path 55426",
    d: "M41.34,17.058l-.823,1.233A1.775,1.775,0,0,1,38,18.744L21.955,7.141a.887.887,0,0,0-1.04,0L4.871,18.744a1.775,1.775,0,0,1-2.514-.451l-.826-1.235a1.775,1.775,0,0,1,.436-2.423L20.4,1.305a1.775,1.775,0,0,1,2.08,0L40.9,14.636A1.775,1.775,0,0,1,41.34,17.058Z",
    transform: "translate(-0.582 -0.969)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55427",
    "data-name": "Path 55427",
    d: "M21.4,7.9,5.5,19.4V38.584H38.332V19.4L22.436,7.9A.887.887,0,0,0,21.4,7.9Z",
    transform: "translate(-1.063 -1.731)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55428",
    "data-name": "Path 55428",
    d: "M11.5,37.5v4.437h2.662V40.162H31.909v1.775h2.662V37.5Z",
    transform: "translate(-1.739 -5.083)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55429",
    "data-name": "Path 55429",
    d: "M1.775,0H4.437V23.071H1.775A1.775,1.775,0,0,1,0,21.3V1.775A1.775,1.775,0,0,1,1.775,0Z",
    transform: "translate(32.832 27.98) rotate(90)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55430",
    "data-name": "Path 55430",
    d: "M1.775,0H7.986V15.085H1.775A1.775,1.775,0,0,1,0,13.31V1.775A1.775,1.775,0,0,1,1.775,0Z",
    transform: "translate(28.396 19.994) rotate(90)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55431",
    "data-name": "Path 55431",
    d: "M.887,0H4.437V7.986H.887A.887.887,0,0,1,0,7.1V.887A.887.887,0,0,1,.887,0Z",
    transform: "translate(24.846 23.543) rotate(90)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityFinanceAccommodation);
export default __webpack_public_path__ + "static/media/university-finance-accommodation.8b217100c97025e5e415e69e2ab245c5.svg";
export { ForwardRef as ReactComponent };